import { AGENCY_BUNDLE_ID } from './AgencyBundleProducts';

export const productPrices = [
	{
		name: 'Essential Addons',
		4372: {
			1: { basePrice: 59.99, dealPrice: 44.99 },
			3: { basePrice: 119.99, dealPrice: 83.99 },
			4: { basePrice: 299.99, dealPrice: 194.99 },
		},
	},
	{
		name: 'NotificationX',
		99658: {
			1: { basePrice: 49, dealPrice: 37 },
			3: { basePrice: 199, dealPrice: 139 },
			4: { basePrice: 399, dealPrice: 259 },
		},
	},
	{
		name: 'BetterDocs',
		342422: {
			1: { basePrice: 69, dealPrice: 52 },
			2: { basePrice: 149, dealPrice: 104 },
			3: { basePrice: 299, dealPrice: 194 },
		},
	},
	{
		name: 'SchedulePress',
		78593: {
			1: { basePrice: 49, dealPrice: 37 },
			3: { basePrice: 149, dealPrice: 104 },
			4: { basePrice: 399, dealPrice: 259 },
		},
	},
	{
		name: 'EmbedPress',
		414494: {
			1: { basePrice: 69, dealPrice: 52 },
			2: { basePrice: 199, dealPrice: 139 },
			3: { basePrice: 399, dealPrice: 259 },
		},
	},
	{
		name: 'BetterLinks',
		764539: {
			1: { basePrice: 99, dealPrice: 74 },
			2: { basePrice: 249, dealPrice: 174 },
			3: { basePrice: 399, dealPrice: 259 },
		},
	},
	{
		name: 'Better Payment',
		1738966: {
			1: { basePrice: 59, dealPrice: 44 },
			2: { basePrice: 199, dealPrice: 139 },
			3: { basePrice: 499, dealPrice: 324 },
		},
	},
	{
		name: 'Essential Blocks',
		1677666: {
			1: { basePrice: 49, dealPrice: 37 },
			2: { basePrice: 149, dealPrice: 104 },
			3: { basePrice: 349, dealPrice: 227 },
			6: { basePrice: 399, dealPrice: 279 },
		},
	},
	{
		name: 'xSpeed Cache',
		1971379: {
			1: { basePrice: 58, dealPrice: 29 },
			2: { basePrice: 98, dealPrice: 49 },
			3: { basePrice: 198, dealPrice: 99 },
			4: { basePrice: 398, dealPrice: 199 },
		},
	},
	{
		name: 'ThinkRank',
		1971322: {
			1: { basePrice: 99, dealPrice: 49.5 },
			2: { basePrice: 159, dealPrice: 79.5 },
			3: { basePrice: 249, dealPrice: 124.5 },
		},
	},
	{
		name: 'Agency Bundle',
		[AGENCY_BUNDLE_ID]: {
			1: { basePrice: 399, dealPrice: 279 },
			2: { basePrice: 999, dealPrice: 649 },
			5: { basePrice: 33, dealPrice: 25 },
		},
	},
];

export function getProductPrice(
	downloadId,
	priceId,
	lookingFor = 'basePrice',
	isMonthly = false
) {
	const product = productPrices.find(item => item[downloadId]);
	if (product) {
		const price = product[downloadId][priceId];
		if (price) {
			if (isMonthly && price?.[lookingFor]) {
				return Math.trunc((price[lookingFor] / 12) * 100, 2) / 100;
			}

			return price[lookingFor];
		}
	}
	return null;
}
